import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	buttonClose: 'js-m-lightbox__close',
	lightboxMask: 'js-m-lightbox__mask',
	stateLightboxVisible: "state-m-lightbox--visible",
	stateLightboxCarousel: "state-m-lightbox--carousel",
	lightbox: "m-lightbox",
	carouselPrev: "js-m-lightbox__prev",
	carouselNext: "js-m-lightbox__next",
};

@createModule('Lightbox')
/**
 * Lightbox module implementation.
 *
 * @author Ellen Xia
 */
export class Lightbox extends TerrificSpec {
	$ctx: JQuery;
	carouselLength: number;
	currentIndex: number;
	nextIndex: number;

	start(resolve: () => void) {
		this.$ctx = $(this._ctx);
		this.carouselLength = $("html").find(`.${classes.lightbox}`).length;

		this.$ctx.find(`.${classes.buttonClose}`).on("click", this.closeLightbox.bind(this));
		this.$ctx.find(`.${classes.lightboxMask}`).on("click", this.closeLightbox.bind(this));
		
		this.$ctx.find(`.${classes.carouselPrev}`).on("click", this.carouselPrevClick.bind(this));
		this.$ctx.find(`.${classes.carouselNext}`).on("click", this.carouselNextClick.bind(this));

		this.lightboxAnchorClick();
		this.lightboxCarousel();

		resolve();
	}

	closeLightbox() {
		this.$ctx.removeClass(classes.stateLightboxVisible);
		$('html').removeClass('no-scrolling--without-scrollbar');
	}

	lightboxAnchorClick() {
		const lightboxID = this.$ctx.attr('id');
		$('html').on("click",'[href="#' + lightboxID + '"]',() => {
			this.$ctx.addClass(classes.stateLightboxVisible);
			$('html').addClass('no-scrolling--without-scrollbar');
		});
	}

	lightboxCarousel() {
		const $lightbox = $("html").find(`.${classes.lightbox}`);
		if($lightbox.length > 1) {
			$lightbox.addClass(classes.stateLightboxCarousel);
			$lightbox.each((i: any, e: any) => {
				$(e).attr("data-carousel-index", i+1);
			});
		}
	}

	carouselPrevClick(ev: any) {
		const $currentCarousel = $(ev.currentTarget).parents(`.${classes.lightbox}`)
		$currentCarousel.removeClass(classes.stateLightboxVisible);
		this.currentIndex = $currentCarousel.data('carousel-index');
		if(this.currentIndex == 1) {
			this.nextIndex = this.carouselLength;
		} else {
			this.nextIndex = this.currentIndex - 1;
		}
		$('[data-carousel-index="' + this.nextIndex + '"]').addClass(classes.stateLightboxVisible);
	}

	carouselNextClick(ev: any) {
		const $currentCarousel = $(ev.currentTarget).parents(`.${classes.lightbox}`)
		$currentCarousel.removeClass(classes.stateLightboxVisible);
		this.currentIndex = $currentCarousel.data('carousel-index');
		if(this.currentIndex == this.carouselLength) {
			this.nextIndex = 1;
		} else {
			this.nextIndex = this.currentIndex + 1;
		}
		$('[data-carousel-index="' + this.nextIndex + '"]').addClass(classes.stateLightboxVisible);
	}

	stop() { }
}
